export const STATIONS = [
  { key: "running", label: "Course" },
  { key: "skierg", label: "SkiErg" },
  { key: "sled_push", label: "Sled Push" },
  { key: "sled_pull", label: "Sled Pull" },
  { key: "burpee_broad_jump", label: "Burpees" },
  { key: "rowing", label: "Rameur" },
  { key: "farmers_carry", label: "Farmer Carry" },
  { key: "sandbag_lunges", label: "Sandbag Lunges" },
  { key: "wall_balls", label: "Wall Balls" },
];

export const RACES = [
  { id: "paris", name: "HYROX Paris", city: "Paris", date: "2026-10-17" },
  { id: "lyon", name: "HYROX Lyon", city: "Lyon", date: "2026-11-14" },
  { id: "marseille", name: "HYROX Marseille", city: "Marseille", date: "2026-12-05" },
  { id: "montpellier", name: "HYROX Montpellier", city: "Montpellier", date: "2027-01-23" },
  { id: "nice", name: "HYROX Nice", city: "Nice", date: "2027-02-13" },
  { id: "bordeaux", name: "HYROX Bordeaux", city: "Bordeaux", date: "2027-03-06" },
  { id: "lille", name: "HYROX Lille", city: "Lille", date: "2027-03-27" },
  { id: "toulouse", name: "HYROX Toulouse", city: "Toulouse", date: "2027-04-17" },
  { id: "other", name: "Autre course", city: "", date: null },
];

export const CITIES = ["Paris", "Lyon", "Marseille", "Lille", "Bordeaux", "Nantes", "Toulouse", "Montpellier", "Nice", "Strasbourg", "Rennes", "Grenoble", "Clermont-Ferrand", "Rouen", "Metz"];

export const CATEGORIES = [
  { id: "men", label: "Doubles Hommes", short: "Hommes" },
  { id: "women", label: "Doubles Femmes", short: "Femmes" },
  { id: "mixed", label: "Doubles Mixtes", short: "Mixtes" },
];

export const LEVELS = [
  { id: "beginner", label: "Débutant", sub: "Premier HYROX ou presque" },
  { id: "intermediate", label: "Intermédiaire", sub: "1 à 3 courses, tu connais les stations" },
  { id: "advanced", label: "Confirmé", sub: "Plusieurs courses, tu vises un chrono" },
  { id: "elite", label: "Compétition", sub: "Podium, qualifs, top classement" },
];

export const GOALS = [
  { id: "finish", label: "Finir la course", time: 100 },
  { id: "discover", label: "Découvrir le format Doubles", time: 95 },
  { id: "beat_pb", label: "Battre mon précédent temps", time: 85 },
  { id: "sub_130", label: "Passer sous 1h30", time: 88 },
  { id: "sub_115", label: "Passer sous 1h15", time: 73 },
  { id: "sub_100", label: "Passer sous 1h", time: 58 },
  { id: "compete", label: "Performance / compétition", time: 65 },
];

export const AVAILABILITY = [
  { id: "weekday_morning", label: "Semaine · matin" },
  { id: "weekday_noon", label: "Semaine · midi" },
  { id: "weekday_evening", label: "Semaine · soir" },
  { id: "saturday", label: "Samedi" },
  { id: "sunday", label: "Dimanche" },
];

export const WEIGHTS = [
  { key: "race", label: "Course & format", max: 25 },
  { key: "target_time", label: "Temps cible", max: 20 },
  { key: "complementarity", label: "Complémentarité", max: 20 },
  { key: "level", label: "Niveau", max: 15 },
  { key: "distance", label: "Distance", max: 10 },
  { key: "availability", label: "Disponibilité", max: 10 },
];

export const RESULT_FORMATS = ["solo_open", "solo_pro", "doubles_men", "doubles_women", "doubles_mixed", "doubles_pro", "relay"];
export const SEARCH_STATUSES = ["searching", "found", "stopped"];
export const formatSeconds = (s) => `${Math.floor(s / 3600)}:${String(Math.floor((s % 3600) / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
export const parseHms = (txt) => {
  const p = String(txt).trim().split(":").map(Number);
  if (p.some((n) => Number.isNaN(n))) return null;
  if (p.length === 2) return p[0] * 3600 + p[1] * 60;
  if (p.length === 3) return p[0] * 3600 + p[1] * 60 + p[2];
  return null;
};
export const profilePayload = (p, patch = {}) => ({
  first_name: p.first_name, last_name: p.last_name || null, city: p.city, city_country: p.city_country || null, city_lat: p.city_lat ?? null, city_lon: p.city_lon ?? null,
  race: p.race, category: p.category, gender: p.gender, level: p.level, goal: p.goal, target_time: p.target_time, availability: p.availability, scores: p.scores,
  instagram: p.instagram || null, bio: p.bio || null, birth_date: p.birth_date || null, search_status: p.search_status || "searching",
  results: (p.results || []).map(({ city, year, format, time_seconds }) => ({ city, year, format, time_seconds })), ...patch,
});
export const goalShort = (id) => ({ finish: "Finir la course", discover: "Découvrir", beat_pb: "Battre mon temps", sub_130: "Sous 1h30", sub_115: "Sous 1h15", sub_100: "Sous 1h", compete: "Compétition" }[id] || "—");
export const categoryLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label || id;
export const levelLabel = (id) => LEVELS.find((l) => l.id === id)?.label || id;
export const formatTime = (m) => `${Math.floor(m / 60)}h${String(m % 60).padStart(2, "0")}`;
export const formatDate = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");
